import { Component, Input, Output } from '@angular/core';
import {
  SaleElectronicPrescriptionAnswer,
} from '../../models/sale-electronic-prescription-answer';
import {
  BuyImportRequestModal
} from '../../models/buy-import-modal';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ViewChild, ElementRef, SimpleChanges, EventEmitter } from '@angular/core';
import { PCTableInputModel, PCTableOutputModel } from '../../models/pc-table-input-model';
// import { MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';

@Component({
  selector: 'app-cash-multi-payment',
  templateUrl: './cash-multi-payment.component.html',
  styleUrls: ['./cash-multi-payment.component.css']
})
export class CashMultiPaymentComponent {
  public constructor(
    private logger: LoggerService,
    private apiService: UserApiService,
  ) {
    this.getCompany();
    this.backendJson = new BuyImportRequestModal();
  }
  public modalSuccessConfirm: boolean = false;
  public paymendAmount: number = 0;
  public companyList: any[] = [];
  public factorList: any[] = [];
  public selectedFactor: any[] = [];
  public companyId: string = '';
  public loading: boolean = false;
  public showPayment: boolean = false;
  public prescriptions?: SaleElectronicPrescriptionAnswer;
  public backendJson: BuyImportRequestModal;
  public showFactors: boolean = false;

  @Input() thisItem: any;
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();

  public getCompany() {
    try {
      this.loading = true;
      let url = `DrugDistributor?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.companyList = [];
          }
          if (result.succeeded) {
            this.companyList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.title,
              persianName: current.title,
              companyTypeId: current.companyTypeId,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public changeCompany(event) {
    if (event.id) {
      this.backendJson.drugDistributorId = event.id;
      this.getFactor();
    }
  }

  selectCompany(company: any) {
    // وقتی روی شرکت کلیک می‌شود، فاکتورها را نمایش بده
    this.showFactors = true;
    this.loadCompanyFactors(company);
  }
  
  loadCompanyFactors(company: any) {
    // اینجا لیست فاکتورها را از شرکت انتخاب‌شده بارگذاری کنید
    this.factorList = company.factors;
  }

  public getFactor() {
    try {
      this.loading = true;
      let url = `BuyFactor/Distributor/${this.backendJson.drugDistributorId}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.factorList = [];
          }
          if (result.succeeded) {
            this.factorList = result.data!.map((current) => ({
              id: current.id,
              totalPrice: current.totalPrice,
              factorDate: current.factorDate,
              factorId: current.factorId,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkAndPay() {
    //TODO: validation 
    this.showPayment = true;
  }

  public callParent(method: string) {
    this.parentActionOutput.emit(new PCTableOutputModel(method, undefined));

  }

  public selectFactor(item: any, index: number) {
    if (item.selected) {
      item.selected = false;
      this.selectedFactor.slice(index, 1);
      this.paymendAmount -= item.totalPrice;
    } else {
      item.selected = true;
      this.selectedFactor.push(item);
      this.paymendAmount += item.totalPrice;
    }
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {

      case 'Successed':
        this.modalSuccessConfirm = false;
        break;

    }
  }


}
